<script>
import App from "@/pages/layouts/app.vue";
import FullCalendar from '@jntestapparatuur/appointments';
import Card from "@/pages/components/card.vue";
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Modal from "@/pages/components/modal.vue";
import Create from "@/pages/appointments/create.vue"
import Update from "@/pages/appointments/update.vue"
import moment from "moment";
import Calendar from "@/pages/appointments/mixins/calendar";

export default {
  mixins: [FormElements, Calendar],
  components: {Card, App, Modal, Create, Update},
  props: {
    googleClientSideKey: {
      type: String
    }
  },
  data() {
    return {
      employees: []
    }
  },
  async mounted() {
    let calendar = await (new FullCalendar({
      scope: this.$refs.calendar
    })).init();

    this.getResources();

    this._addEventListeners(calendar);
    this.addEventListeners(calendar);
  },
  computed: {
    activeEmployees() {
      return this.employees.filter((employee) => employee.active)
    }
  },
  methods: {
    addEventListeners(calendar) {
      let $calendar = $(this.$refs.calendar);
      $calendar.on('openFilterModal', this.openFilterModal.bind(this));
      calendar.on('dateClick', this.openAddModal.bind(this));
      calendar.on('eventClick', this.openUpdateModal.bind(this));
      this.$watch('employees', this.setResources.bind(this), {deep: true});
    },

    async getResources() {
      let employees = await this.getEmployees(1, []);
      let activeIds = this.getActiveIds();
      let alwaysTrue = activeIds.length < 1;

      this.employees = employees.map(employee => {
        let active = activeIds.includes(employee.id);
        if (alwaysTrue) {
          active = true;
          activeIds.push(employee.id);
        }

        return {
          id: employee.id,
          title: employee.name,
          active: active ? 1 : 0
        }
      });

      if (alwaysTrue) {
        localStorage.setItem('activeEmployeeIds', JSON.stringify(activeIds));
      }
    },

    async getEmployees(page, employees) {
      let perPage = 100;

      await $.ajax({
        url: route('api.v1.users.index'),
        data: {
          length: perPage,
          start: (perPage * page) - perPage
        },
        success: (response) => {
          for (let key in response.data) {
            employees.push(response.data[key]);
          }
          if (employees.length < response.recordsTotal) {
            employees = this.getEmployees(page + 1, employees);
          }
        }
      });

      return employees;
    },

    setResources(employees) {
      let calendar = $(this.$refs.calendar).data('calendar');
      employees.forEach(employee => {
        let resource = calendar.getResourceById(employee.id);
        if (employee.active && !resource) {
          calendar.addResource(employee);
        } else if (!employee.active && resource) {
          resource.remove();
        }
      });

      this.setActiveIds(employees.filter((employee) => employee.active).map(employee => employee.id))
    },

    setActiveIds(activeIds = []) {
      localStorage.setItem('activeEmployeeIds', JSON.stringify(activeIds));
    },

    getActiveIds() {
      return JSON.parse(localStorage.getItem('activeEmployeeIds') ?? '[]');
    },

    openFilterModal() {
      this.$refs.filters.open();
    },

    openAddModal(event) {
      let user = {};
      let startDate = '';
      let endDate = '';

      if (event) {
        user = {
          id: event.resource._resource.id,
          name: event.resource.title,
        };

        startDate = moment(event.date).format('YYYY-MM-DD HH:mm');
        endDate = moment(event.date).add(30, 'minutes').format('YYYY-MM-DD HH:mm');
      } else {
        startDate = moment().set('minute', 0).format('YYYY-MM-DD HH:mm');
        endDate = moment().set('minute', 0).add(30, 'minutes').format('YYYY-MM-DD HH:mm');
      }

      this.$refs.addFormModal.open(startDate, endDate, user);
    },

    openUpdateModal(event) {
      let data = event.event._def;

      let appointment = {
        id: data.publicId,
        name: data.title,
        description: data.extendedProps.description,
        user_id: data.resourceIds[0],
        customer_id: data.extendedProps.customer_id,
        products: data.extendedProps.products,
        default_duration: data.extendedProps.default_duration,
      }

      let customer = {
        id: data.extendedProps.customer_id,
        name: data.extendedProps.customer,
        products: data.extendedProps.customer_products,
      }

      let user = {
        id: data.resourceIds[0],
        name: data.extendedProps.employee,
      }

      let startDate = moment.utc(event.event._instance.range.start).format('YYYY-MM-DD HH:mm');
      let endDate = moment.utc(event.event._instance.range.end).format('YYYY-MM-DD HH:mm');

      this.$refs.updateFormModal.open(startDate, endDate, appointment, user, customer);
    },
  }
}
</script>

<template>
  <App title="Agenda">
    <template #topButtons>
      <button @click="openAddModal(null)" class="btn btn-primary">
        <i class="bi bi-plus-lg"></i>
        Agenda item toevoegen
      </button>
    </template>

    <Card>
      <div ref="calendar"></div>
    </Card>

    <Modal id="filters" title="filters" ref="filters">
      <h3 class="card-title mb-3">Werknemers</h3>

      <div class="d-flex flex-column">
        <Checkbox
            v-for="employee in employees"
            name="employees[]"
            :key="employee.id"
            v-model="employee.active"
            :label="employee.title"
            :checked="employee.active == 1"
            :value="1"
            :id="`employee-${employee.id}`"
        />
      </div>

      <template #footer>
        <div class="btn btn-secondary" data-bs-dismiss="modal">Sluiten</div>
      </template>
    </Modal>

    <Create @update:calendar="updateCalendar" :googleClientSideKey="googleClientSideKey" ref="addFormModal"/>
    <Update @update:calendar="updateCalendar" ref="updateFormModal"/>
  </App>
</template>